<ng-content *ngIf="cart$ | async as cart">
  <div class="select-cart-modal">
    <span class="select-cart-modal-title">{{ 'cart.modal.edit.title' | translate }}</span>
    <span
      class="select-cart-modal-description"
      [innerHTML]="'cart.modal.edit.description' | translate: { name: cart.name, id: cart.code }"
    ></span>

    <div class="select-cart-modal-footer">
      <cx-button (click)="onCancel()" class="btn-outline w-100">{{ 'cart.modal.edit.cancel' | translate }}</cx-button>
      <cx-button (click)="onSubmit()" class="w-100">{{ 'cart.modal.edit.submit' | translate }}</cx-button>
    </div>
  </div>
</ng-content>
